const config = {
  apiBaseUrl: 'https://zjy749dwvl.execute-api.eu-west-1.amazonaws.com/prod',
  defaultLandingPage: 'login',
  locationByHost: {
    'cuikbook.info': 'penicuik',
    'dollysdirectory.info': 'roslin',
  },
  titleByHost: {
    'dollysdirectory.info': "Dolly's Directory",
  },
  auth: {
    region: 'eu-west-1',
    clientId: '3f9c4eo6a3dh24q077fpvnn1en',
    flow: 'USER_PASSWORD_AUTH',
  },
  featuresByLocation: {
    penicuik: {
      enableMMP: true,
      enableDarkMode: true,
    },
    loanhead: {
      enableMMP: false,
      enableDarkMode: false,
    },
    roslin: {
      enableMMP: false,
      enableDarkMode: false,
    },
  },
  branding: {
    logos: ['practice_logo.png'],
    logosByLocation: {
      loanhead: ['practice_logo_loanhead.png'],
      penicuik: ['practice_logo_penicuik.png'],
      roslin: ['practice_logo_roslin.png'],
    },
    logoCentred: {
      loanhead: false,
      penicuik: false,
      roslin: true,
    },
  },
};

export { config };
